<template>
  <div class='sidebar'>
    <el-menu :default-active="$route.name" :default-openeds="['待办','系统设置']">
      <el-menu-item index="公告" @click="$router.push({name:'公告'})">
        <template slot="title">
          <i class="el-icon-message-solid"></i>
          <span>公告</span>
        </template>
      </el-menu-item>
      <el-menu-item index="我要投诉" @click="$router.push({name:'我要投诉'})">
        <template slot="title">
          <i class="el-icon-circle-plus"></i>
          <span>我要投诉</span>
        </template>
      </el-menu-item>
      <el-menu-item index="我的" @click="$router.push({name:'我的'})">
        <template slot="title">
          <i class="el-icon-user-solid"></i>
          <span>我的</span>
        </template>
      </el-menu-item>
      <el-submenu index="待办">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>待办</span>
        </template>
        <el-menu-item index="新投诉" @click="$router.push({name:'新投诉'})">新投诉</el-menu-item>
        <el-menu-item index="已转交" @click="$router.push({name:'已转交'})">已转交</el-menu-item>
        <el-menu-item index="待回复" @click="$router.push({name:'待回复'})">待回复</el-menu-item>
        <el-menu-item index="待公布" @click="$router.push({name:'待公布'})">待公布</el-menu-item>
      </el-submenu>
      <el-submenu index="系统设置" v-if="$store.state.user.userInfo.user_type=='8'||$store.state.user.userInfo.user_type=='9'">
        <template slot="title">
          <i class="el-icon-s-tools"></i>
          <span>系统设置</span>
        </template>
        <el-menu-item index="接收人管理" @click="$router.push({name:'接收人管理'})">接收人管理</el-menu-item>
        <el-menu-item index="投诉类型管理" @click="$router.push({name:'投诉类型管理'})">投诉类型管理</el-menu-item>
        <el-menu-item index="意见箱管理员" @click="$router.push({name:'意见箱管理员'})" v-if="$store.state.user.userInfo.user_type=='9'">意见箱管理员</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  components: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style scoped>

</style>